import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import useDeleteQuestion from 'hooks/API/DELETE/useDeleteQuestion';
import useToaster from 'hooks/useToaster';
import { useParams } from 'react-router-dom';

function QuestionDeleteModal({ modalConfig = {}, closeModal }) {
  const { courseID, chapterID, quizID } = useParams();

  const { mutate, isLoading, isError } = useDeleteQuestion({
    quizID,
    courseID,
    chapterID,
  });

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function deleteQuestion() {
    mutate(modalConfig.data ?? {});
    closeModal();
  }

  return (
    <AppModal open={modalConfig.show} closeModal={closeModal} size="sm">
      <AppModalHeader>Delete Question</AppModalHeader>
      <AppModalBody>
        <p className="modal-sub-text">Do you want to delete this question?</p>

        <div className="app-l-modal-btn-block">
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={deleteQuestion}>
            YES<sup>*</sup>
          </AppButton>
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={closeModal}>
            NO
          </AppButton>
        </div>

        <p className="modal-sub-note">
          <sup>*</sup>Please note that this action is irreversible
        </p>
      </AppModalBody>
      <AppModalFooter></AppModalFooter>
    </AppModal>
  );
}

export default QuestionDeleteModal;
